import { useEffect } from 'react';

import { useErrorScreenContext } from 'context/error/error';
import { useToastMessageContext } from 'context/toast/toast';
import { useDetectLocation } from 'hooks/common/useDetectLocation';

import { useAppStore } from '../../common/useAppStore';

import { useHandleFullScreenError } from './handlers/useHandleFullScreenError';
import { useHandleMigrationError } from './handlers/useHandleMigrationError';
import { useHandleToastError } from './handlers/useHandleToastError';
import { resolveError } from './utils/resolveError';

export function useAppErrorReaction() {
  const { appStore } = useAppStore();
  const errorScreenContext = useErrorScreenContext();
  const toastMessageContext = useToastMessageContext();
  const handleToastError = useHandleToastError();
  const handleMigrationError = useHandleMigrationError();
  const handleFullScreenError = useHandleFullScreenError();
  const apiErrorList = appStore.apiError ? Object.values(appStore.apiError) : [];
  const { isPlayerLocation } = useDetectLocation();
  const isFullPlayerError = isPlayerLocation(window.location.pathname);

  useEffect(() => {
    async function handleErrorEffect() {

      const { commonError, isToastError, isMigrationError, isFullScreenError, id } = resolveError();
      if (isMigrationError) {
        handleMigrationError(commonError);
      } else if (isFullScreenError) {
        handleFullScreenError(commonError, id, Boolean(apiErrorList.length));

      } else if (isToastError) {
        handleToastError();

      } else {
        console.warn(`ApiError: ${commonError.code} - ${commonError.title} (${commonError.message})`);
      }
    }
    // isFullPlayerError is for avoiding cleaning problems inside the player (errors in the player are handled separately) 
    if (!apiErrorList.length && !isFullPlayerError) {
      errorScreenContext.clearError();
      toastMessageContext.clearToast();

      return;
    }

    handleErrorEffect();
  }, [apiErrorList.length]);
}
